import { scrollRight } from "./scrollNav";
window.scrollRight = scrollRight;
document.addEventListener("DOMContentLoaded", function () {
    var _a;
    const urlPage = window.location.pathname;
    const optionMenuLeft = urlPage.split('/').join('');
    if (document.getElementById(optionMenuLeft)) {
        (_a = document.getElementById(optionMenuLeft)) === null || _a === void 0 ? void 0 : _a.classList.add('active');
        const element = document.getElementById('menu-left');
        var elem = document.querySelector('#' + optionMenuLeft);
        var rect = elem === null || elem === void 0 ? void 0 : elem.getBoundingClientRect();
        if (element && rect) {
            element.scrollLeft = rect.left - 10;
        }
    }
});
